(function() {
  var loaded = false;

  var activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

  function activateDeferred() {
    if (loaded) return;
    loaded = true;

    activityEvents.forEach(function(name) {
      window.removeEventListener(name, activateDeferred, false);
    });

    document.querySelectorAll('script[data-src]').forEach(function(el) {
      el.src = el.dataset.src;
      delete el.dataset.src;
    });

    document.querySelectorAll('link[data-href]').forEach(function(el) {
      el.href = el.dataset.href;
      delete el.dataset.href;
    });

    document.querySelectorAll('.deferredScript').forEach(function(el) {
      el.type = 'text/javascript';
    });

    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
      document.dispatchEvent(new CustomEvent('StartKernelLoading'));
    }, 400);
  }

  activityEvents.forEach(function(name) {
    window.addEventListener(name, activateDeferred, { once: true, passive: true });
  });

  window.addEventListener('load', function() {
    setTimeout(activateDeferred, 9000);
  });
})();

/* === APO gate fix (2026-07-16) ===
   On product pages where MageWorx APO has no options (Apliiq/Printful POD items),
   window.mwApoReady stays false forever, so the theme's VariantSelects code disables
   Add-to-Cart and waits out an 8s timeout. This releases the gate immediately on
   products that have no APO instance. APO products (which register an instance and/or
   set mwApoReady=true) are left untouched. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  function apoActive() {
    try {
      return !!(window.mwApo && typeof window.mwApo.instances === 'function' && window.mwApo.instances().length > 0);
    } catch (e) { return false; }
  }
  function release() {
    if (window.mwApoReady === true) return;
    if (apoActive()) return;
    window.mwApoReady = true;
    try {
      document.dispatchEvent(new CustomEvent('mw-apo:ready', { detail: { source: 'custom-js-no-apo-fix' } }));
    } catch (e) {}
  }
  var started = Date.now();
  var poll = setInterval(function () {
    if (apoActive() || window.mwApoReady === true) { clearInterval(poll); return; }
    if (Date.now() - started > 2500) { clearInterval(poll); release(); }
  }, 150);
})();

(() => {
  const menuSelector = '.mega-menu[data-id="leagues"]';

  const alignLeagueHubs = () => {
    const menu = document.querySelector(menuSelector);
    if (!menu) return;

    const columns = [...menu.querySelectorAll('.main-li-cls')]
      .map((column) => {
        const list = column.querySelector(':scope > .list-unstyled-cls');
        const hub = [...(list?.children || [])].find((item) => item.matches('li[aria-hidden]') && item.textContent.includes('League Hubs'));
        if (!list || !hub) return null;

        const items = [...list.children];
        return { hub, nodes: items.slice(items.indexOf(hub)) };
      })
      .filter(Boolean);

    if (!window.matchMedia('(min-width: 990px)').matches || !menu.open) {
      columns.forEach(({ nodes }) => nodes.forEach((node) => node.style.removeProperty('transform')));
      return;
    }

    columns.forEach(({ nodes }) => nodes.forEach((node) => node.style.setProperty('transform', 'none', 'important')));
    const targetTop = Math.max(...columns.map(({ hub }) => hub.getBoundingClientRect().top));

    columns.forEach(({ hub, nodes }) => {
      const offset = targetTop - hub.getBoundingClientRect().top;
      nodes.forEach((node) => node.style.setProperty('transform', offset ? 'translateY(' + offset + 'px)' : 'none', 'important'));
    });
  };

  const bindLeagueHubAlignment = () => {
    const menu = document.querySelector(menuSelector);
    if (!menu || menu.dataset.hubAlignmentBound) return;
    menu.dataset.hubAlignmentBound = 'true';
    menu.addEventListener('toggle', () => requestAnimationFrame(alignLeagueHubs));
    menu.addEventListener('pointerenter', () => requestAnimationFrame(alignLeagueHubs));
    window.addEventListener('resize', () => requestAnimationFrame(alignLeagueHubs));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLeagueHubAlignment, { once: true });
  } else {
    bindLeagueHubAlignment();
  }
})();


(() => {
  const removeRegionMenuArrows = () => {
    document.querySelectorAll('.mega-menu[data-id="regions"] .main-li-cls > a').forEach((link) => {
      [...link.childNodes].forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) node.nodeValue = node.nodeValue.replace(/\s*>\s*$/, '');
      });
      link.querySelectorAll('svg').forEach((icon) => icon.remove());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeRegionMenuArrows, { once: true });
  else removeRegionMenuArrows();
})();

(() => {
  const addRegionSubmenuCarets = () => {
    document.querySelectorAll('.mega-menu[data-id="regions"] .main-li-cls').forEach((item) => {
      const link = item.querySelector(':scope > a');
      if (!link || !item.querySelector(':scope > ul') || link.querySelector('.region-submenu-caret')) return;
      const caret = document.createElement('span');
      caret.className = 'region-submenu-caret';
      caret.setAttribute('aria-hidden', 'true');
      caret.textContent = '⌄';
      link.append(caret);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addRegionSubmenuCarets, { once: true });
  else addRegionSubmenuCarets();
})();
